{
  "title": "Tiêu đề",
  "album": "Album",
  "artist": "Nghệ sĩ",
  "year": "Ngày phát hành",
  "comment": "Bình luận",
  "synopsis": "Tóm tắt",
  "externalLink": "Liên kết ngoài",
  "composer": "Nhà soạn nhạc",
  "copyright": "Bản quyền",
  "size": "Kích thước",
  "bit_rate": "Tốc độ bit"
}
